// Pour le dashboard Docteur  
import React from "react";
import DashboardLayout from "../../pages/Dashboard";

const DoctorDashboard: React.FC = () => {
  return <DashboardLayout role="doctor" />;
};

export default DoctorDashboard;